/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-interaction-field-color);
  --opacity: 1;
  --label-color: var(--nve-sys-interaction-field-color);
  --label-text-transform: none;
  --label-font-weight: var(--nve-ref-font-weight-medium);
  --label-font-size: var(--nve-ref-font-size-100);
  --_label-width: var(--label-width, 180px);
}

[internal-host] {
  color: var(--color);
  opacity: var(--opacity);
}

::slotted(label) {
  font-weight: var(--label-font-weight) !important;
  font-size: var(--label-font-size) !important;
  color: var(--label-color) !important;
  cursor: var(--cursor) !important;
  text-transform: var(--label-text-transform) !important;
}

:host([layout*='horizontal-inline']) ::slotted([nve-control]),
:host([layout*='vertical-inline']) ::slotted([nve-control]) {
  --control-height: var(--nve-sys-interaction-field-height);
}

slot[name='label'] {
  grid-area: label;
  display: block;
  align-self: center;
}

slot[name='messages'] {
  grid-area: messages;
  display: block;
}

.input-slot {
  grid-area: input;
  display: flex;
  flex-flow: column wrap;
  gap: var(--nve-ref-space-sm) var(--nve-ref-space-md);
}

:host([layout*='-inline']) .input-slot {
  flex-direction: row;
}

[name='messages']:not(:has-slotted),
[name='label']:not(:has-slotted) {
  display: none !important;
}

/* fallback for :has-slotted */
.no-messages {
  & slot[name='messages'] {
    display: none !important;
  }
}

/* fallback for :has-slotted */
.no-label {
  & slot[name='label'] {
    display: none !important;
  }
}

[internal-host] {
  display: grid;
  gap: var(--nve-ref-space-xs);
  align-items: start;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    'label label label'
    'input input input'
    'messages messages messages';

  &.no-messages {
    grid-template-areas:
      'label label label'
      'input input input';
  }

  &.no-label {
    & slot[name='messages'] {
      grid-template-areas:
        'input input input'
        'messages messages messages';
    }
  }

  &.no-label.no-messages {
    grid-template-areas: 'input input input';
  }
}

:host([layout='vertical-inline']) [internal-host] {
  grid-template-areas:
    'label label label'
    'input input input'
    'messages messages messages';
}

:host([layout='vertical-inline']) [internal-host].no-messages {
  grid-template-areas:
    'label label label'
    'input input input';
}

:host([layout='horizontal']) [internal-host] {
  grid-template-columns: var(--_label-width) minmax(auto, max-content) auto;
  grid-template-areas:
    'label input input'
    '. messages messages';
}

:host([layout='horizontal']) [internal-host].no-messages {
  grid-template-areas: 'label input input';
}

:host([layout='horizontal-inline']) [internal-host] {
  grid-template-columns: var(--_label-width) minmax(auto, max-content) auto;
  grid-template-areas:
    'label input input'
    '. messages messages';
}

:host([layout='horizontal-inline']) [internal-host].no-messages {
  grid-template-areas: 'label input input';
}

:host([layout='horizontal']) slot[name='label'] {
  align-self: start;
}

:host([layout='horizontal']) ::slotted(label) {
  align-self: start !important;
}
